/**
 * Resolve a public/ asset path for ALL runtimes this bundle ships in.
 *
 * Web deploy is built with homepage "/" (PUBLIC_URL "") → "/images/x.svg".
 * The Electron build loads via file:// and is built with PUBLIC_URL=./ —
 * there a RELATIVE "./images/x.svg" is only correct until the first
 * history.pushState: BrowserRouter rewrites the document URL (file:///call/42)
 * and every later-mounted <img> would resolve against the route path and 404.
 * So for a relative PUBLIC_URL we resolve against the URL the bundle was
 * loaded from, captured at module init — before any routing can run.
 *
 * Never reference public/ assets with a bare absolute string — always go
 * through this helper.
 */
const initialBase = typeof document !== "undefined" ? document.baseURI : "";

export function assetUrl(path: string): string {
  const publicUrl = process.env.PUBLIC_URL || "";
  // Web / PWA / Capacitor: absolute-from-root works and stays stable.
  if (!publicUrl || publicUrl.startsWith("/")) return publicUrl + path;
  // Electron (PUBLIC_URL "." or "./"): pin to the bundle's original base URL.
  try {
    return new URL(publicUrl.replace(/\/+$/, "") + path, initialBase).href;
  } catch {
    return publicUrl + path;
  }
}
